export interface ThroughputMonitoredServiceApiModel {
  itemId: number;
  name?: string;
  orderNumber: number;
  throughput: number;
  txBitRate: number;
  rxBitRate: number;
}

export interface ThroughputMonitoredServiceViewModel {
  itemId: number;
  name?: string;
  orderNumber: number;
  throughput: number;
  txBitRate: number;
  rxBitRate: number;
  outgoingTrafficUtilisationPercentage?: number;
  incomingTrafficUtilisationPercentage?: number;
}

export const mapThroughputMonitoredServiceApiModelToThroughputMonitoredServiceViewModel = (
  apiMeasurements: ThroughputMonitoredServiceApiModel[],
): ThroughputMonitoredServiceViewModel[] =>
  apiMeasurements.map(apiMeasurement => ({
    itemId: apiMeasurement.itemId,
    name: apiMeasurement.name,
    orderNumber: apiMeasurement.orderNumber,
    throughput: apiMeasurement.throughput,
    txBitRate: apiMeasurement.txBitRate,
    rxBitRate: apiMeasurement.rxBitRate,
    outgoingTrafficUtilisationPercentage: calculateUtilisationPercentage(apiMeasurement.txBitRate, apiMeasurement.throughput),
    incomingTrafficUtilisationPercentage: calculateUtilisationPercentage(apiMeasurement.rxBitRate, apiMeasurement.throughput)
  }));

const calculateUtilisationPercentage = (
  bitRate: number|undefined,
  throughput: number
): number|undefined =>
  bitRate === undefined ? undefined : bitRate / throughput * 100;